export const eventNameEnums = {
  RESPONSE_CREATE: 'responseCreate',
  RESPONSE_UPDATE: 'responseUpdate',
  RESPONSE_DELETE: 'responseDelete',
  THREAD_META_UPDATE: 'threadMetaUpdate',
  REACTIONS_UPDATE: 'reactionsUpdate'
}
